__turbopack_context__.v({
  "description": "intro-module-scss-module__Q1VI5G__description",
  "intro": "intro-module-scss-module__Q1VI5G__intro",
  "introAnimatedTitle": "intro-module-scss-module__Q1VI5G__introAnimatedTitle",
});
